import { config, authHeader } from '../helpers'
import { handleHttpResponse } from '../helpers';

export const AddressService = {
    getAddresses,
    addAddress,
    modifyAddress,
    deleteLocation
}

function getAddresses(clientID) {
    const query = `{
        addresses(clientID: "${clientID}")
        {
            id
            country
            postalCode
            localityName
            streetName
            streetNumber
            source
            boxNumber
            customName
        }
      }`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/graphql', ...authHeader() },
        body: query
    };
    return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
        return handleHttpResponse(response)
        .then(data => data.addresses);
      })
  }

function addAddress({ clientID, streetName, streetNumber, country, postalCode, localityName, boxNumber, customName }) {
  const query = `mutation{
    addAddress(
      clientID: ${JSON.stringify(clientID)},
      streetName: ${streetName ? JSON.stringify(streetName) : null},
      streetNumber: ${streetNumber ? JSON.stringify(streetNumber) : null},
      country: ${country ? JSON.stringify(country) : null},
      postalCode: ${postalCode ? JSON.stringify(postalCode) : null},
      localityName: ${localityName ? JSON.stringify(localityName) : null},
      boxNumber: ${boxNumber ? JSON.stringify(boxNumber) : null},
      customName: ${customName ? JSON.stringify(customName) : null}
    ) {
      id
    }
  }`;

  const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/graphql', ...authHeader() },
      body: query
  };
  return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
      return handleHttpResponse(response)
      .then(data => {
          return data.addAddress;
      });
    })
}

function modifyAddress({ id, customName, country, postalCode, localityName, streetName, streetNumber, boxNumber}) {
    const query = `mutation{
        modifyAddress(
            locationID: ${JSON.stringify(id)},
            addressCustomName: ${customName ? JSON.stringify(customName) : null},
            country: ${country ? JSON.stringify(country) : null},
            postalCode: ${postalCode ? JSON.stringify(postalCode) : null},
            localityName: ${localityName ? JSON.stringify(localityName) : null},
            streetName: ${streetName ? JSON.stringify(streetName) : null},
            streetNumber: ${streetNumber ? JSON.stringify(streetNumber) : null},
            boxNumber: ${boxNumber ? JSON.stringify(boxNumber) : null},
        ) {
            ID
        }
    }`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/graphql', ...authHeader() },
        body: query
    };
    return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
        return handleHttpResponse(response)
        .then(data => {
            return data.modifyAddress;
        });
      })
}

function deleteLocation(locationID) {
    const query = `mutation{
        deleteLocation(locationID: ${JSON.stringify(locationID)})
        {
            id
        }
    }`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/graphql', ...authHeader() },
        body: query
    };
    return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
        return handleHttpResponse(response)
        .then(data => {
            return data.deleteLocation;
        });
      })
}